export const WIZARD_RESULT_LIMIT = 8;
export const WIZARD_MAX_OPTIONS = 6;
export const WIZARD_MIN_COVERAGE = 0.65;
export const WIZARD_SKIPPED = "__skipped__";

export const WIZARD_QUESTIONS = [
    {
        id: "equipmentFamily",
        titleKey: "select.wizard.questions.equipmentFamily",
        optionKeyPrefix: "select.wizard.options.equipmentFamily",
        values: ["machine", "cable", "free_weight", "bodyweight", "cardio", "other"],
        showWhen: [],
    },
    {
        id: "implement",
        titleKey: "select.wizard.questions.implement",
        optionKeyPrefix: "select.wizard.options.implement",
        values: ["barbell", "dumbbell", "kettlebell", "specialty_bar", "medicine_ball", "other"],
        showWhen: [{ field: "equipmentFamily", in: ["free_weight"] }],
    },
    {
        id: "support",
        titleKey: "select.wizard.questions.support",
        optionKeyPrefix: "select.wizard.options.support",
        values: ["bench", "seat", "standing", "floor", "hanging", "other"],
        showWhen: [],
    },
    {
        id: "movement",
        titleKey: "select.wizard.questions.movement",
        optionKeyPrefix: "select.wizard.options.movement",
        values: ["press", "pull", "squat_or_lunge", "hinge", "raise_or_curl", "core_or_carry"],
        showWhen: [],
    },
    {
        id: "mainArea",
        titleKey: "select.wizard.questions.mainArea",
        optionKeyPrefix: "select.wizard.options.mainArea",
        values: ["chest", "back", "shoulders", "legs", "arms", "core"],
        showWhen: [],
    },
];
